import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { type ServerApiError } from '@wellesley/openapi/helpers'

const getUsernameConflictError = (e: unknown) => {
  const error = e as FetchBaseQueryError
  const isConflictError = error?.status === 409
  const message =
    (error?.data as ServerApiError)?.errorCode === 'UserNameIsReserved'
      ? 'Restricted words detected. Please, try alternatives'
      : 'Username already in use. Please, try another one'

  return {
    message,
    isError: isConflictError,
  }
}

export default getUsernameConflictError
